import { Box, Container, Divider, Paper, Typography } from '@mui/material';
import Seo from '../components/Seo';
import { SUPPORT_PAGE } from '../content/support';

// A page rather than a mailto link: on a phone without a mail account set up, mailto opens
// the Mail app's "Add Account" screen (#402).
const SupportPage = () => (
    <Container maxWidth="md" sx={{ py: 6 }}>
        <Seo
            title="Support | StockMaid"
            description="How to reach StockMaid support, what to include, and answers to common questions about Premium, cancelling and refunds."
            canonicalPath="/support"
        />
        <Paper elevation={0} sx={{ p: { xs: 3, md: 5 } }}>
            <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
                Support
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Last updated: {SUPPORT_PAGE.lastUpdated}
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ '& p': { mb: 2, lineHeight: 1.8 } }}>
                <Typography variant="body1">
                    Something not working, or a question we have not answered here? Write to{' '}
                    <strong>{SUPPORT_PAGE.email}</strong> and we will get back to you.
                </Typography>
                <Typography variant="body1">{SUPPORT_PAGE.include}</Typography>

                <Typography variant="h5" component="h2" fontWeight="600" sx={{ mt: 4, mb: 2 }}>
                    Common questions
                </Typography>
                {SUPPORT_PAGE.questions.map(({ question, answer }) => (
                    <Box key={question} sx={{ mb: 3 }}>
                        <Typography variant="h6" component="h3" fontWeight="600" sx={{ mb: 1 }}>
                            {question}
                        </Typography>
                        <Typography variant="body1">{answer}</Typography>
                    </Box>
                ))}
            </Box>
        </Paper>
    </Container>
);

export default SupportPage;
